import { gql } from '@apollo/client';

const getDepartmentHistory = gql`
  query DepartmentHistory($filters: FilterObjectInput, $departmentId: Int!) {
    DepartmentHistory(filters: $filters, departmentId: $departmentId) {
      type
      id
      name
      status
      datetime
      take_at
      picture_type
      picture_id
      created_at
      take_at
      caregiver {
        name
        firstname
        user {
          preferredUsername
          username
        }
      }
      position {
        id
        name
        room {
          id
          name
        }
      }
    }
  }
`;

export default getDepartmentHistory;
